import type { BandRole } from './types';

/** Representative band centres, in nanometres. Roles without one sit off the axis. */
export const NM: Partial<Record<BandRole, number>> = {
  coastal: 443, blue: 490, green: 560, pan: 590, red: 665,
  rededge: 717, rededge1: 705, rededge2: 740, rededge3: 783,
  nir: 842, nir08: 865, watervapour: 945, cirrus: 1375, swir16: 1610, swir22: 2190,
};

export const ROLES: BandRole[] = [
  'unassigned', 'coastal', 'blue', 'green', 'red', 'rededge', 'rededge1', 'rededge2',
  'rededge3', 'nir', 'nir08', 'watervapour', 'cirrus', 'swir16', 'swir22', 'pan',
  'thermal', 'alpha', 'index', 'other',
];

export const COMPRESSION: Record<number, string> = {
  1: 'none', 2: 'CCITT RLE', 5: 'LZW', 6: 'JPEG (old)', 7: 'JPEG', 8: 'Deflate',
  32773: 'PackBits', 32946: 'Deflate', 34712: 'JPEG2000', 34887: 'LERC', 34925: 'LZMA',
  50000: 'ZSTD', 50001: 'WebP', 50002: 'JPEG XL',
};

export const PHOTOMETRIC: Record<number, string> = {
  0: 'WhiteIsZero', 1: 'BlackIsZero', 2: 'RGB', 3: 'Palette', 4: 'Mask',
  5: 'CMYK', 6: 'YCbCr', 8: 'CIELab',
};

export const SAMPLEFMT: Record<number, string> = { 1: 'uint', 2: 'int', 3: 'float', 4: 'undefined' };

/** geotiff.js decodes these; anything else needs an extra decoder. */
export const BROWSER_SAFE_COMPRESSION = new Set([1, 5, 8, 32773, 32946]);
